import {http} from './config/config-relation-register'

export default{
    listar:async(token)=>{
        return  http.get('epocas-alvos',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, item)=>{
        return http.post('epocas-alvos',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('epocas-alvos/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('epocas-alvos/'+item.id_epoca_alvo,item,{
            headers:{
                'Authorization':token
            }
        })
    }

}